import type { PropsWithChildren } from 'react'
import React from 'react'
import { cn } from '@/lib/utils'
import MainHeader from './MainHeader'

import styles from './Layout.module.css'

interface LayoutProps extends PropsWithChildren {
  withHeader?: boolean
  noTopPadding?: boolean
}

const Layout: React.FC<LayoutProps> = ({ children, withHeader = true, noTopPadding = false, ...rest }) => {
  return (
    <>
      {withHeader && <MainHeader />}
      <main className={cn('font-[Sora] min-h-dvh flex flex-col overflow-y-auto bg-gray-100', !noTopPadding && 'pt-16')} {...rest}>
        {children}
      </main>
    </>
  )
}

export default Layout
